module.exports = __webpack_public_path__ + "img/about-us.378dc4a6.png";